import { render, staticRenderFns } from "./new_password.vue?vue&type=template&id=0b8ba97d&lang=pug&"
import script from "./new_password.ts?vue&type=script&lang=ts&"
export * from "./new_password.ts?vue&type=script&lang=ts&"
import style0 from "./new_password.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports